import React from 'react'
import { withRouter } from 'react-router-dom'
import levelData from '../../content/export-modules'
import levelsInfo from '../../content/level-menu'
import { AnimatePresence } from 'framer-motion'
import { PageStoreProvider } from '../../state/pagestore'
import Header from '../Header'
import Footer from '../Footer'
import Popups from '../Popup'

import TextPage from '../TextPage'
import Image from '../Image'
import Video from '../Video'
import Table from '../Table'
import Carousel from '../Carousel'

import MultipleChoice from '../MultipleChoice'

import {
  StyledContent
} from './ContentPage.styled'

const Page = ({ match }) => {
  const { levelID, pageID } = match.params
  const currentLevel = levelData[levelID]
  const currentPageIndex = parseInt(pageID.split('page-')[1]) - 1
  const currentPage = currentLevel.pages[currentPageIndex]
  const onFirstPage = currentPageIndex === 0
  const onLastPage = currentPageIndex === currentLevel.pages.length - 1
  const prevPage = 'page-' + currentPageIndex
  const nextPage = 'page-' + (currentPageIndex + 2)
  const intlKey = levelID + '.' + pageID + '.'
  const pagingInfo = { levelID, prevPage, pageID, nextPage, onFirstPage, onLastPage }
  const interactiveContentTypes = ['mc-standard']
  const allowSkip = currentPage.components.filter(comp => interactiveContentTypes.indexOf(comp.type) > -1).length > 0
  const content = currentPage.components
    .map((component, index) => (
      <React.Fragment
        key={`${levelID}-${pageID}-${component.type}-${index}`}
      >
        {component.type === 'image' && <Image {...component} intlKey={intlKey} />}
        {component.type === 'video' && <Video {...component} />}
        {component.type === 'text' && <TextPage {...component} intlKey={intlKey} />}
        {component.type === 'popup' && <Popups {...component} intlKey={intlKey} />}
        {component.type === 'table' && <Table {...component} intlKey={intlKey} />}
        {component.type === 'carousel' && <Carousel component={component} intlKey={intlKey} />}
        {component.type === 'mc-standard' && <MultipleChoice component={component} intlKey={intlKey} pagingInfo={pagingInfo} />}
      </React.Fragment>
    ))
  return (
    <>
      <PageStoreProvider>
        <Header title={`${levelID}.${pageID}.header`} {...pagingInfo} pageID={pageID} backgroundColor={levelsInfo.levels?.find(lvl => lvl.id === levelID)?.bg} />
        <AnimatePresence exitBeforeEnter>
          <StyledContent
            displaySetting={currentPage.display}
            key={pageID}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            positionTransition
          >
            {content}
          </StyledContent>
        </AnimatePresence>
        <Footer allowSkip={allowSkip} {...pagingInfo} />
      </PageStoreProvider>
    </>
  )
}

export default withRouter(Page)
